import { useQuery } from '@tanstack/react-query'
import { loadInvalidBets } from './invalidBetsData'
import type { InvalidBetsQuery } from './invalidBetsTypes'

/** Invalid Bets — live CM-API `getVARBets` / `searchIBLogs`. */
export function useInvalidBets(query: InvalidBetsQuery) {
  return useQuery({
    queryKey: ['cm', 'invalid-bets', query],
    queryFn: () => loadInvalidBets(query),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
